/** Super-admin billing service — /api/v1/admin/billing/* */
import api from '../shared/services/api';

export interface Payment {
  id: string;
  tenant_id: string | null;
  tenant_name?: string | null;
  amount: number;
  currency: string;
  status: string;
  period_start: string | null;
  period_end: string | null;
  paid_at: string | null;
  note: string | null;
  created_at: string | null;
}

export interface RevenueSummary {
  currency: string;
  mrr: number;
  received_this_month: number;
  outstanding: number;
  monthly: { month: string; received: number }[];
}

export interface PaymentCreate {
  tenant_id: string;
  amount: number;
  currency?: string;
  status?: string;
  period_start?: string;
  period_end?: string;
  paid_at?: string;
  note?: string;
}

export async function listPayments(): Promise<Payment[]> {
  const r = await api.get<Payment[]>('/api/v1/admin/billing/payments');
  return r.data;
}

export async function recordPayment(body: PaymentCreate): Promise<Payment> {
  const r = await api.post<Payment>('/api/v1/admin/billing/payments', body);
  return r.data;
}

export async function getRevenue(months = 12): Promise<RevenueSummary> {
  const r = await api.get<RevenueSummary>('/api/v1/admin/billing/revenue', { params: { months } });
  return r.data;
}
